export const Colors = {
  afxBlue: '#282561',
  violetblue: '#5208c9',
  dusk: '#44476a',
  dark: '#31344b',
  midnightBlue: '#191970',
  black: '#333333',
  brownishgrey: '#91a0ab',
  weirdgreen: '#3ce35b',
  white: 'white',
  grey: 'grey',
  red: 'red',
  amber: '#FFBF00',
  blurEffect: 'rgba(60,60,60,0.5)',
  teal: '#1687a7',
  darkerTeal: '#137590',
  lightBlue: '#e8f4fa',
  orange: '#F18805',
  seaBlue: '#00A6A6',
  darkerseaBlue: '#008585',
  creamBackground: '#f6f5f5',
  lightGrey: '#f0f0f0',
  lightMidGrey: '#D3D3D3',
  mattegreen: '#48A14D',
  matteblack: '#171717',
  blue: '#5208C9',
  purple: '#c67ace',
  skyBlue: '#51c4d3',
  neavyBlue: '#152238',
  pearl: '#fbfcf8',
  darkRed: '#720000',
  blueGray: '#899DB0',
  serenity: '#C3CDD6',
  royalBlue: '#15227A',
  lightRed: '#ffe8e8',
  lightAmber: '#FFEEBD',
  darkAmber: '#533E00',
  lightMatteGreen: '#EDF6ED',
  midlightgrey: '#e6e6e6',
  mandy: '#ed5a72',
  themeBlue: '#293c76',
  cloudBurst: '#20275F',
};
